import { Component, EventEmitter, Input, OnInit, OnDestroy, Output, computed, model, signal, ViewChild, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { BookManagementService } from '../../book-management.service';
import {
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';

@Component({
  selector: 'app-simple-chip-filter',
  templateUrl: './simple-chip-filter.component.html',
  styleUrls: ['./simple-chip-filter.component.scss'],
  standalone: false,
})
export class SimpleChipFilterComponent implements OnInit, OnDestroy {
  private bmSvc = inject(BookManagementService);

  @ViewChild(MatAutocompleteTrigger) chipFilterAuto: MatAutocompleteTrigger;
  @Input() label;
  @Input() fieldVar;
  @Input() value;
  @Output() toggleFiltersUpdated = new EventEmitter();
  unsubscribe: Subject<any> = new Subject();
  chips = signal([]);
  separatorKeysCodes: number[] = [ENTER, COMMA];
  currentChip = model('');
  chipOptions = signal([]);
  filteredChips = computed(() => {
    const currentChip = this.currentChip().toLowerCase();
    return currentChip
      ? this.chipOptions().filter(chip =>
          chip.toLowerCase().includes(currentChip)
        )
      : this.chipOptions().slice();
  });

  ngOnInit(): void {
    this.bmSvc.updateBmOptions$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(filterVals => {
        if (filterVals[this.fieldVar]) {
          this.chipOptions.set(filterVals[this.fieldVar]);
        }
      });

    this.bmSvc.clearBmFilters$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => {
        this.chips.set([]);
        this.value.update(() => []);
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  clearChipSearch() {
    this.currentChip.set('');
  }

  removeChip(chipOption: string): void {
    this.chips.update(chips => {
      const index = chips.indexOf(chipOption);
      if (index < 0) {
        return chips;
      }

      chips.splice(index, 1);
      return [...chips];
    });
    this.value.update(chips => {
      const index = chips.indexOf(chipOption);
      if (index < 0) {
        return chips;
      }

      chips.splice(index, 1);
      return [...chips];
    });
    this.toggleFiltersUpdated.emit(true);
  }

  chipSelected(event: MatAutocompleteSelectedEvent): void {
    if (!this.chips().includes(event.option.value)) {
      this.chips.update(chips => [...chips, event.option.value]);
      this.value.update(chips => [...chips, event.option.value]);
    }
    this.currentChip.set('');
    event.option.deselect();
    this.toggleFiltersUpdated.emit(true);
  }

  chipDisplay(val) {
    const dispChip = this.chipOptions().find(opt => opt.NPN === val);
    if (dispChip) {
      return `${dispChip.Name} - ${dispChip.NPN}`;
    }

    return val;
  }

  onBlur() {
    setTimeout(() => {
      this.chipFilterAuto.autocomplete.showPanel = false;
    }, 250);
  }
}
